import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/maintenance/service-operations')({
  component: lazyRouteComponent(() => import('&/features/settings/maintenance/pages/service-operations-page')),
  staticData: { titleKey: 'serviceOperations' },
});
